import { gql } from 'graphql-request'

export const GET_READER_TOP_TIME_SPENDER = gql`
  query GetTopTimeSpend(
    $limit: Int
    $endDate: DateTime
    $startDate: DateTime
    $orderBy: GetUserTopTimeSpendOrderBy
  ) {
    getTopTimeSpend(
      limit: $limit
      endDate: $endDate
      startDate: $startDate
      orderBy: $orderBy
    ) {
      userId
      username
      userTimeSpend
    }
  }
`
